<template>
    <div class="bg-white px-3 index">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item label="用户ID">
                        <el-input v-model="userID" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item>
                     <el-form-item label="用户昵称">
                        <el-input v-model="userName" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="时间">
                        <el-date-picker v-model="times" size="small" type="daterange" value-format="yyyy-MM-dd"
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>

                    <el-form-item>
                        <el-button type="primary" icon="el-icon-printer" size="small" plain @click="openExportExcel">
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="date" label="时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="user_id" label="用户ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="user.username" label="用户昵称" width="150">
                    <template slot-scope="{row}">
                        <span>{{row.user_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="send_count" label="发帖量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="length" label="发帖总字数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="comment_count" label="回帖量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="duration" label="登录时长(秒)" show-overflow-tooltip></el-table-column>
                <el-table-column prop="new_login_time" label="最近一次登录" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <!-- 导出 -->
        <el-dialog title="导出数据" :visible.sync="exportModal" center width="30%">
            <el-form :model="exportForm" ref="exportForm" label-width="80px">
                <el-form-item label="时间范围" required>
                    <el-date-picker size="small" v-model="exportForm.time" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exportModal = false">取 消</el-button>
                <el-button type="primary" :loading='exporloading' @click="exportExcel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import tinymce from '@/components/common/tinymce.vue';
    export default {
        components: {
            tinymce,
        },
        data() {
            return {
                userID: '',
                userName:'',
                times: [],

                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 10,
                height: null,
                // 
                eid: '0',
                dataId: '',
                exportForm: {
                    time: [],
                },
                exportModal: false,
                exporloading: false,
                user_id: ''
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        created() {},
        mounted() {
            let that = this
            this.begin()
            that.getHeight()

        },
        methods: {
            openExportExcel() {
                this.exportForm.time = []
                this.exportModal = true
            },
            exportExcel() {
                if (this.exportForm.time.length == 0) return this.$message.error('请选择时间范围')
                let val = this.exportForm.time
                let params = ''
                if (val && Array.isArray(val)) {
                    params += `&start=${val[0]}`
                    params += `&end=${val[1]}`
                }
                let url = `/admin/pc/report/excelFlow?data_id=${this.userID}&username=${this.userName}`

                this.exporloading = true
                this.axios.post(url + params, {}, {
                    token: true,
                    responseType: 'blob'
                }).then(res => {
                    if (res.status == 200) {
                        this.exportModal = false
                        let url = window.URL.createObjectURL(new Blob([res.data]))
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        let filename = new Date().getTime() + '.xlsx';
                        link.setAttribute('download', filename)
                        document.body.appendChild(link)
                        link.click()
                    } else if (res.data.code != 200) {
                        this.$message('暂无数据')
                    }
                    this.exporloading = false

                }).catch(err => {
                    this.exporloading = false

                })
            },
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 10
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios.post(
                        `/admin/pc/report/communityUserActivities`, {
                            user_id: this.userID,
                            username: this.userName,
                            start: this.times ? this.times[0] : '',
                            end: this.times ? this.times[1] : '',
                        }, {
                            token: true
                        })
                    .then(response => {
                        that.loading = false
                        console.log(response);
                        that.tableData = response.data.data
                    })
                    .catch(error => {})
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$prompt(`要删除此评论,请输入删除理由`, '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal: true,
                    beforeClose(action, instance, done) {
                        if (action == 'confirm') {
                            if (instance.inputValue) {
                                that.del(done, instance.inputValue, row)
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '删除理由不得为空！'
                                });
                            }
                        } else {
                            done()
                        }
                    }
                }).then(({
                    value
                }) => {}).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消'
                    });
                });
            },
            del(d, v, r) {
                let url = `/admin/pc/delComment`
                axios.post(url, {
                    id: r.id,
                    role: 'admin',
                    destroy_remark: v,
                    user_id: r.user_id
                }, {
                    token: true
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        d()
                        this.search()
                    } else {

                    }
                })
            },

        },

    };
</script>


<style scoped>
    .con_de {
        /* border: 1px solid red; */
        /* width: 200px; */
        width: 100%;
        max-height: 200px;
        overflow-y: scroll;
        line-height: 18px;
        position: relative;
        top: 7px;
        background-color: rgb(247, 245, 245);
        border-radius: 5px;
        padding: 5px;
    }

    .imgs {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 5px;
    }

    .lefts {
        max-height: 500px;
        overflow: auto;
    }

    .delt {
        color: red;
        font-size: 20px;
    }

    .blues {
        color: #409eff;
    }

    .concon {
        background: #f5f5f5;
        padding: 10px;
        border-radius: 10px;
    }

    .zanbtn {
        width: 30px;
        display: flex;
        /* border: 1px solid red; */
        cursor: pointer;
    }

    .zanbtn img {
        width: 100%;
        display: block;
    }

    .singleimg {
        width: 50px;
    }

    .singleimg img {
        width: 100%;
        height: 100%;
        display: block;
    }

    .imgbox {
        display: flex;

        flex-wrap: wrap;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .tablimg {
        margin: 2px 5px;
    }
</style>